// https://vuex.vuejs.org/en/actions.html

import mgr from '@/services/securityService'
import router from '@/router'
import store from '@/store'

export default {
  async Authenticate ({ dispatch, commit }, returnPath) {
    const user = await dispatch('GetUser') // see if the user details are in local storage
    if (user && user.expired === false) {
      commit('SetAuthentication', true)
      commit('SetUser', user)
    } else {
      // get the current path if no returnPath is passed
      if (!returnPath) {
        returnPath = router.history.current.path
      }
      await dispatch('SignIn', returnPath)
    }
    return user
  },
  async GetUser () {
    try {
      const user = await mgr.getUser()
      return user
    } catch (err) {
      // todo should do something else
      console.log(err)
    }
  },
  SignIn ({ dispatch, commit }, returnPath) {
    window.localStorage.setItem('auth-returnPath', returnPath)
    returnPath
      ? mgr.signinRedirect({ state: returnPath })
      : mgr.signinRedirect()
  },
  async HandleLoginCallback () {
    mgr.signinRedirectCallback()
      .then(() => {
      var returnToUrl = window.localStorage.getItem('auth-returnPath')
      if (!returnToUrl) {
        returnToUrl = '/'
        }
        window.history.replaceState({},
          window.document.title,
          window.location.origin + returnToUrl)
      router.push({ path: returnToUrl })
    })
      .catch(() => {
        router.push({ name: 'Unauthorized' })
    })
  },
  Logout () {
    console.log(mgr.signoutRedirect())
  },
}
